/* eslint-disable no-restricted-globals */
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "md-editor-rt/lib/style.css";
import "./index.css";
import {
  useDeleteClassifiedMutation,
  useGetClassifiedQuery,
  useUpdateClassifiedMutation,
} from "../../features/supabase/usecase/classifieds";
import { useGetCategoriesQuery } from "../../features/supabase/usecase/categories";
import { useGetFacilitiesQuery } from "../../features/supabase/usecase/facilities";
import { useGetAmenitiesQuery } from "../../features/supabase/usecase/amenities";
import DraftEditor from "../../components/DraftEditor";
import { AddCircle, CrossIcon, DeleteIcon } from "../../components/icons";
import storageService from "../../app/services/storageService";
import { toast } from "react-toastify";
import { ReactSortable } from "react-sortablejs";
import Counter from "../../components/Button/Counter";
import SelectFileButton from "../../components/Button/SelectFileButton";
import { StandaloneSearchBox, useJsApiLoader } from "@react-google-maps/api";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import { diffWords } from "diff";
import SuccessModal from "../../components/Modals/SuccessModal";
import { useGetLocationsQuery } from "../../features/supabase/usecase/locations";
import { useGetSingleUserQuery, useLazyGetSingleUserQuery } from "../../features/supabase/usecase/users";
import { useSelector } from "react-redux";
import { selectAuth } from "../../features/auth/authSlice";
// import { EditorState } from "draft-js";

const Edit = () => {
  const params = useParams();
  const id = parseInt(params.id);
  const isJob = params.type === "job" || false;

  const {
    data: classified,
    error,
    isLoading,
    refetch,
  } = useGetClassifiedQuery(id);

  const {
    data: categories,
    error: categoriesError,
    isLoading: categoriesLoading,
  } = useGetCategoriesQuery();

  const {
    data: facilities,
    error: facilitiesError,
    isLoading: facilitiesLoading,
  } = useGetFacilitiesQuery();
  const {
    data: amenities,
    error: amenitiesError,
    isLoading: amenitiesLoading,
  } = useGetAmenitiesQuery();

  const pricingSchedules = ["Per Year", "Per Month", "Per Week", "Per Night"];

  const cities = [
    "Crown Heights",
    "New Haven",
    "Monsey",
    "Florida",
    "Kingston",
  ];


  const crossStreets = [
    'Eastern Parkway',
    'Union Street',
    'Carroll Street',
    'Crown Street',
    'Montgomery Avenue',
    'Empire Boulevard',
    'Lefferts Avenue',
    'East New York Avenue',
    'Maple Street',
    'Midwood Street',
    'Utica Avenue',
    'Schenectady Avenue',
    'Troy Avenue',
    'Albany Avenue',
    'Kingston Avenue',
    'Brooklyn Avenue',
    'New York Avenue',
    'Nostrand Avenue',
  ]

  const [state, setState] = React.useState({});

  const category = React.useMemo(() => {
    if (!categories || !state.category_id) return "";
    const result = categories.find((e) => e.id === parseInt(state.category_id));
    return result;
  }, [state.category_id, categories]);

  const [open, setOpen] = React.useState(false);

  const [selectedAmenities, setAmenities] = React.useState([]);

  const [selectedFacilities, setFacilities] = React.useState([]);

  const [showConfirm, setShowConfirm] = React.useState(false);

  const [properties, setProperties] = React.useState({});

  const [files, setFiles] = React.useState([]);

  const [updateClassified, updateResult] = useUpdateClassifiedMutation();

  const [deleteClassified, deleteResult] = useDeleteClassifiedMutation();

  const user = useSelector(selectAuth);
  const [userState, setUserState] = React.useState();

  const [getUserState] = useLazyGetSingleUserQuery();

  React.useEffect(() => {
    if (user.user) {
      getUserState(user.user.id).then(({ data }) => {
        setUserState(data)
      })
    }
  }, [user.user]);

  const { data: locations } = useGetLocationsQuery({
    categoryId: state.category_id,
  });

  const toastId = React.useRef(null);

  const [range, setRange] = React.useState(7);

  const isJobApplication = React.useMemo(() => {
    return category.type === "job";
  }, [category]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA3l-W7zveLhLhT79IdxEaeGmsCE0xJgF8",
    libraries: ["places"],
    nonce: "codedecoders",
  });

  React.useEffect(() => {
    if (classified) {
      setState(classified);
      // const desc = classified.description ? String(classified.description) : "";
      // setDescription(desc);
      console.log(classified);
      setProperties(classified.properties ?? {});
      if (classified.properties)
        setFiles(
          classified.properties.images.map((e, i) => {
            return { path: e.toString() };
          })
        );

      setFacilities(() => {
        var facilities = {};
        classified.facilities.forEach(({ facility, quantity }) => {
          facilities[facility.id] = quantity;
        });
        return facilities;
      });
      setAmenities(() => {
        var amenities = {};
        classified.amenities.forEach(({ amenity }) => {
          amenities[amenity.id] = true;
        });
        return amenities;
      });
    }
  }, [classified]);

  const handleInputChange = (e) => {
    setState((val) => ({
      ...val,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFaculityChange = ({ key, value }) => {
    setFacilities((val) => ({
      ...val,
      [key]: value,
    }));
  };

  const handleAmenityChange = (key) => {
    setAmenities((val) => ({
      ...val,
      [key]: !val[key],
    }));
  };

  const handleAddressField = (e) => {
    console.log(e.target.name, e.target.value);
    setProperties((val) => ({
      ...val,
      address_fields: {
        ...val.address_fields,
        [e.target.name]: e.target.value,
      },
    }));
  };

  const handleStateChange = ({ key, value }) => {
    setState((val) => ({
      ...val,
      [key]: value,
    }));
  };

  const handlePropertiesChange = (e) => {
    setProperties((val) => ({
      ...val,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePropertieStateChange = (key, value) => {
    setProperties((val) => ({
      ...val,
      [key]: value,
    }));
  };

  const handlePlacesChanged = () => {
    const places = inputRef.current.getPlaces();

    if (places && places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      const countryComponent = addressComponents.find((component) =>
        component.types.includes("country")
      );
      const streetComponent = addressComponents.find((component) =>
        component.types.includes("route")
      );
      const apartmentComponent = addressComponents.find((component) =>
        component.types.includes("street_number")
      );
      const cityComponent =
        addressComponents.find((component) =>
          component.types.includes("locality")
        ) ||
        addressComponents.find((component) =>
          component.types.includes("sublocality")
        );
      const stateComponent = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      const postalCodeComponent = addressComponents.find((component) =>
        component.types.includes("postal_code")
      );

      const address = place.formatted_address;
      const country = countryComponent ? countryComponent.long_name : "";
      const streetAddress = streetComponent ? streetComponent.long_name : "";
      const apartment = apartmentComponent ? apartmentComponent.long_name : "";
      const city = cityComponent ? cityComponent.long_name : "";
      const state = stateComponent ? stateComponent.long_name : "";
      const postalCode = postalCodeComponent
        ? postalCodeComponent.long_name
        : "";

      setState({
        ...state,
        address,
        country,
        streetAddress,
        apartment,
        city,
        state,
        postalCode,
      });
      console.log(places);
    } else {
      console.log("No places found or the API did not return any results.");
    }
  };

  const filterLocations = React.useMemo(() => {
    return (locations || []).filter(
      (val) => val.id === parseInt(state.location_id || "0")
    );
  }, [locations, state]);

  function checkDescriptionDifference(desc1, desc2) {
    const diff = diffWords(desc1, desc2);

    let diffCharCount = 0;

    diff.forEach((part) => {
      if (part.added || part.removed) {
        diffCharCount += part.value.length; // Count the length of added/removed parts
      }
    });

    console.log(`Total differing characters: ${diffCharCount}`);

    if (diffCharCount > 100) {
      return true;
    } else {
      return false;
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    let pending = false;
    console.log("Submitting with selected amenities:", selectedAmenities);
    const toastId = toast("Classified is being submitted...", {
      autoClose: false,
      closeButton: false,
      isLoading: true,
    });

    // state contains the classified table data
    // properties contains the classified_properties table data
    // selectedAmenities contains the selected amenities
    // selectedFacilities contains the selected facilities
    // files contains the images to be uploaded and replace the existing images if any
    const result = [];
    for (const file of files) {
      console.log(classified.metadata);
      if (classified.metadata.additionalPictures === 0 && result.length === 5) {
        break;
      }
      if (file.file && file.path) {
        pending = true;
        await storageService.update(file.file, file.path);
        result.push(file.path);
      } else if (file.file) {
        pending = true;
        var { path } = await storageService.upload(file.file);
        result.push(path);
      } else {
        result.push(file.path);
      }
    }

    if (classified.category_id !== state.category_id) {
      pending = true;
    }

    if (classified.title !== state.title) {
      pending = true;
    }

    const difference = checkDescriptionDifference(
      classified?.description ?? "",
      state?.description ?? ""
    );
    console.log(difference);
    if (difference) {
      pending = true;
    }

    function getCategoryTable(categoryId) {
      switch (categoryId) {
        case 1:
          return "for_sale_fields";
        case 2:
          return "for_rent_fields";
        case 3:
          return "short_term_fields";
        case 4:
          return "job_fields";
        case 5:
          return "Other";
        default:
          throw new Error("Invalid category id");
      }
    }

    const classifiedData = {
      id: state.id,
      category_id: state.category_id,
      title: state.title,
      description: state.description,
      email: state.email,
      phone: state.phone,
      whatsapp: state.whatsapp,
      location_id: state.location_id,
      featured: state.featured,
      status: pending ? (userState?.is_pre_approved ? "approved" : "pending") : state.status,
      created_by: state.created_by,
      created_at: state.created_at,
    };

    console.log(classifiedData);

    const response = await updateClassified({
      categoryTable: getCategoryTable(state.category_id),
      classified: classifiedData,
      classifiedProperties: {
        ...classified.properties,
        ...properties,
        ...(result.length > 0 ? { images: result } : {}),
      },
      amenities: Object.keys(selectedAmenities)
        .filter((k) => selectedAmenities[k])
        .map((k) => parseInt(k)),
      facilities: Object.entries(selectedFacilities).map(([k, v]) => ({
        id: parseInt(k),
        quantity: parseInt(v),
      })),
    });
    if (response.error) {
      toast.update(toastId, {
        render:
          response.error || "An error occurred while updating the classified",
        type: "error",
        autoClose: 5000,
        isLoading: false,
        closeButton: true,
      });
    } else {
      toast.dismiss(toastId);
      if (pending) {
        setOpen(true);
      } else {
        navigate("/dashboard?tab=approved");
      }
    }
  };

  const inputRef = React.useRef(null);

  const navigate = useNavigate();

  const onDeleteConfirm = async () => {
    // const result = confirm("Are you sure you want to delete this ad?");
    // if (result) {
    toastId.current = toast("Classified is being deleted...", {
      autoClose: false,
      closeButton: false,
      isLoading: true,
    });
    await deleteClassified(parseInt(params.id));
    setShowConfirm(false);
    // }
  };

  const onClose = () => {
    setShowConfirm(false);
  };

  React.useEffect(() => {
    if (deleteResult.isSuccess) {
      toast.update(toastId.current, {
        render: "Classified has been deleted successfully",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
      });
      navigate("/");
      window.location.reload();
    }
    if (deleteResult.isError) {
      toast.update(toastId.current, {
        render:
          deleteResult.error.message ||
          "An error occurred while deleting the classified",
        type: "error",
        autoClose: 5000,
        isLoading: false,
        closeButton: true,
      });
    }
  }, [deleteResult]);

  if (
    isLoading ||
    categoriesLoading ||
    facilitiesLoading ||
    amenitiesLoading ||
    !classified
  ) {
    return (
      <section className="edit-page-base">
        <div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="submit-skeleton-row">
            <div className="skeleton submit-skeleton-button"></div>
            <div className="skeleton submit-skeleton-button"></div>
          </div>
        </div>
      </section>
    );
  }
  return (
    <div className="edit-page-main">
      <form
        className="edit-page-base"
        onSubmit={onSubmit}
        onKeyDown={(event) => {
          // Check if the pressed key is Enter and if the target is an input element
          if (event.key === "Enter" && event.target.tagName === "INPUT") {
            event.preventDefault(); // Prevent form submission on Enter key
          }
        }}
      >
        <span className="edit-page-header">Edit Classified</span>

        <div className="edit-form-field">
          <span className="edit-form-header" style={{ display: "inline" }}>
            Categories
            <sup style={{ fontSize: "smaller", verticalAlign: "top" }}>*</sup>
          </span>
          <select
            disabled
            name="category_id"
            onChange={(e) => {
              handleStateChange({
                key: e.target.name,
                value: parseInt(e.target.value),
              });
            }}
            value={state.category_id}
            required
          >
            {categories.map((e, i) => {
              return <option value={e.id}>{e.name}</option>;
            })}
          </select>
        </div>
        <div className="edit-form-field">
          <span className="edit-form-header" style={{ display: "inline" }}>
            Title
            <sup style={{ fontSize: "smaller", verticalAlign: "top" }}>*</sup>
          </span>
          <span className="form-subheader" style={{
            color: 'gray'
          }}>Title limit 65 characters</span>
          <input
            placeholder="Write your title here"
            name="title"
            onChange={handleInputChange}
            value={state.title}
            minLength={10}
            maxLength={65}
            required
          />
          <div className="title-counter">{state?.title?.length ?? 0}/65 characters used</div>
        </div>
        {category.type !== "others" && (
          <>
            <div className="edit-form-field">
              <span className="edit-form-header">
                Choose a Location <span> (optional)</span>
              </span>
              <select
                name="location_id"
                onChange={handleInputChange}
                value={state.location_id}
              >
                <option value="">{"Select location"}</option>
                {(locations || []).map((location, i) => {
                  return (
                    <option value={location.id}>{location.location}</option>
                  );
                })}
              </select>
            </div>
            {state.location_id !== "" && category.type !== "job" && (
              <div className="edit-form-field">
                <span className="edit-form-header">
                  Address <span> (optional)</span>
                </span>
                {isLoaded && (
                  <StandaloneSearchBox
                    onLoad={(ref) => (inputRef.current = ref)}
                    onPlacesChanged={handlePlacesChanged}
                  >
                    <input
                      type="text"
                      name="address"
                      value={properties.address_fields?.address ?? ""}
                      onChange={handleAddressField}
                      tabIndex={0}
                      style={{ width: "calc(100% - 35px)" }}
                      placeholder="Enter your address"
                      onBlur={() => {
                        if (!properties?.address_fields?.address) {
                          console.log("address not found");
                          setProperties((prevState) => ({
                            ...prevState,
                            address_fields: {
                              ...prevState.address_fields,
                              address: "",
                            },
                          }));
                        }
                      }}
                    />
                  </StandaloneSearchBox>
                )}
              </div>
            )}
          </>
        )}
        {/* {filterLocations.length > 0 &&
          filterLocations[0].location === "Crown Heights" &&
          category !== "Other" && (
            <div className="edit-form-field">
              <span className="edit-form-header">Cross Streets</span>

              <div className="address-row column">
                <input
                  placeholder="Crown"
                  className="address-field"
                  name={"cross_street1"}
                  value={properties?.address_fields?.cross_street1 ?? ""}
                  onChange={handleAddressField}
                />
                <div>Between</div>
                <input
                  placeholder="Kingston"
                  className="address-field"
                  name={"cross_street2"}
                  value={properties?.address_fields?.cross_street2 ?? ""}
                  onChange={handleAddressField}
                />
                <div>And</div>
                <input
                  placeholder="Brooklyn"
                  className="address-field"
                  name={"cross_street3"}
                  value={properties?.address_fields?.cross_street3 ?? ""}
                  onChange={handleAddressField}
                />
              </div>
            </div>
          )} */}
        {filterLocations.length > 0 && filterLocations[0].location === "Crown Heights" && category.type !== "others" && (
          <div className="edit-form-field">
            <span className="edit-form-header">Cross Streets  <span> (optional)</span></span>
            <div className="address-row column">
              <select className="address-field" name={"cross_street1"} value={properties?.address_fields?.cross_street1 ?? ""} onChange={handleAddressField}>
                <option value="">Select Cross Street</option>
                {crossStreets.map((street, i) => {
                  return <option value={street}>{street}</option>;
                })}
              </select>
              {/* <input
              placeholder="Crown"
              className="address-field"
              name={"cross_street1"}
              value={state?.address_fields?.cross_street1 ?? ""}
              onChange={handleAddressField}
            /> */}
              <div>Between</div>
              <select className="address-field" name={"cross_street2"} value={properties?.address_fields?.cross_street2 ?? ""} onChange={handleAddressField}>
                <option value="">Select Cross Street</option>
                {crossStreets.map((street, i) => {
                  return <option value={street}>{street}</option>;
                })}
              </select>
              {/* <input
              placeholder="Kingston"
              className="address-field"
              name={"cross_street2"}
              value={state?.address_fields?.cross_street2 ?? ""}
              onChange={handleAddressField}
            /> */}
              <div>And</div>
              <select className="address-field" name={"cross_street3"} value={properties?.address_fields?.cross_street3 ?? ""} onChange={handleAddressField}>
                <option value="">Select Cross Street</option>
                {crossStreets.map((street, i) => {
                  return <option value={street}>{street}</option>;
                })}
              </select>
              {/* <input
              placeholder="Brooklyn"
              className="address-field"
              name={"cross_street3"}
              value={state?.address_fields?.cross_street3 ?? ""}
              onChange={handleAddressField}
            /> */}
            </div>
          </div>
        )}
        {isJobApplication && (
          <div className="edit-form-field-row">
            <div className="edit-form-field">
              <span className="form-header">
                Salary
                <span> (optional)</span>
              </span>
              <input
                placeholder="65K-80K"
                name={"salary"}
                value={properties.salary}
                onChange={handlePropertiesChange}
              />
            </div>
          </div>
        )}
        {category.type !== "others" && !isJobApplication && (
          <div className="form-field location">
            <span className="form-header">
              Location info <span> (optional)</span>
            </span>
            <div>
              {facilities.map((facility, i) => {
                if (facility.id === 3 && state.category_id !== 3) {
                  return null;
                }
                return (
                  <div className="location-info">
                    <span>{facility.name}</span>
                    <Counter
                      key={i}
                      value={selectedFacilities[facility.id] ?? 0}
                      onChange={(val) =>
                        handleFaculityChange({
                          key: facility.id,
                          value: val,
                        })
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {category.type !== "others" && !isJobApplication && (
          <div className="form-field">
            <div>
              <span className="form-header">
                Amenities <span> (optional)</span>
              </span>
              <div className="amenities-description">
                Please select those that apply
              </div>
            </div>
            <div className="amenities">
              {amenities.map((amenity, i) => {
                return (
                  <div
                    className={`amenity ${selectedAmenities[amenity.id] ?? false ? "active" : ""
                      }`}
                    key={i}
                    onClick={() => handleAmenityChange(amenity.id)}
                  >
                    <img
                      src={require(`../../images/${amenity.icon}`)}
                      alt={amenity.name}
                      className="amenity-image"
                    />
                    <div className="amenity-title">{amenity.name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {category.type !== "others" && !isJobApplication && (
          <div className="edit-form-field">
            <span className="form-header">
              Location Sqft. <span> (optional)</span>
            </span>
            <div className="sqft">
              <input
                name={"location_sqft"}
                placeholder={"eg: 4,500"}
                type={"text"}
                className="max-size-field"
                onChange={handlePropertiesChange}
                value={properties.location_sqft}
              />
              <span>
                <input
                  type="checkbox"
                  name="newly_renovated"
                  onChange={(e) =>
                    handlePropertieStateChange(e.target.name, e.target.checked)
                  }
                  value={properties.newly_renovated}
                  id="newly_renovated"
                />
                <label for="newly_renovated">Newly Renovated</label>
              </span>
            </div>
          </div>
        )}
        {isJobApplication ? (
          <div className="edit-form-field input">
            <span className="edit-form-header">Add a Company Logo/Image</span>
            {files.length > 0 ? (
              <SelectFileButton
                name={"companyImage"}
                file={files.length > 0 && files[0]}
                props={{
                  single: true,
                }}
                onFileDelete={() => {
                  setFiles((val) => []);
                }}
                setFile={(e) => {
                  setFiles((val) => {
                    return [
                      {
                        ...val[0],
                        file: e,
                      },
                    ];
                  });
                }}
              />
            ) : (
              <SelectFileButton
                setFile={(e) => {
                  setFiles((val) => {
                    if (val.length > 0) {
                      return [
                        {
                          ...val[0],
                          file: e[0],
                        },
                      ];
                    } else {
                      return [{ file: e[0] }];
                    }
                  });
                }}
                label={"add"}
              />
            )}
          </div>
        ) : (
          <div className="form-field">
            <div className="form-header">
              Add a Photo
              <br />
              <span className="amenities-description">
                Drag & Drop to Upload and Re-order Images
              </span>
            </div>
            <ReactSortable
              list={files}
              setList={setFiles}
              filter={".add"}
              delayOnTouchOnly
              swapThreshold={1}
              animation={150}
              className="image-grid"
            >
              {files.map((e, index) => (
                <SelectFileButton
                  key={index}
                  file={e}
                  onFileDelete={() => {
                    setFiles((val) => val.filter((_, i) => i !== index));
                    // setFiles((val) =>
                    //   val.map((e, i) => {
                    //     if (i === index) {
                    //       return { ...e, file: undefined };
                    //     } else {
                    //       return e;
                    //     }
                    //   })
                    // );
                  }}
                  setFile={(file) => {
                    setFiles((val) =>
                      val.map((e, i) => {
                        if (i === index) {
                          return { ...e, file: file };
                        } else {
                          return e;
                        }
                      })
                    );
                  }}
                  label={index == 0}
                />
              ))}
              <SelectFileButton
                setFile={(e) =>
                  setFiles((val) =>
                    val.concat(
                      Array.from(e).map((e) => {
                        return { file: e };
                      })
                    )
                  )
                }
                label={"add"}
              />
            </ReactSortable>
          </div>
        )}
        {category.type !== "others" && !isJobApplication && (
          <div className="edit-form-field">
            <span className="form-header">
              Pricing <span> (optional)</span>
            </span>
            <div className="form-field-row column">
              <input
                name={"price"}
                placeholder={"$"}
                type="number"
                min={0}
                className="max-size-field"
                onChange={handlePropertiesChange}
                value={properties.price}
              />
              {category.name !== "For Sale" && (
                <select
                  name="price_type"
                  value={properties?.price_type}
                  onChange={handlePropertiesChange}
                  className="schedule-field"
                >
                  <option selected disabled>
                    Price Schedule
                  </option>
                  {pricingSchedules
                    .filter((e) => {
                      // if category is short term then remove the for year option
                      return category === "Short Term"
                        ? e !== "Per Year"
                        : true;
                    })
                    .map((e, i) => {
                      return <option value={e}>{e}</option>;
                    })}
                </select>
              )}
              {category.name === "Short Term Rent" && (
                <input
                  name={"min_nights"}
                  placeholder={"Minimum Nights"}
                  type="number"
                  min={0}
                  className="max-size-field"
                  onChange={handlePropertiesChange}
                  value={properties.min_nights}
                />
              )}
            </div>
          </div>
        )}
        <div className="edit-form-field description">
          <span className="edit-form-header">Description</span>
          <DraftEditor
            category={category}
            onChange={(e) => {
              handleStateChange({ key: "description", value: decodeURI(e) });
            }}
            state={classified.description || ""}
          />
        </div>
        <div className="edit-form-header">Contact Information</div>
        <div className="edit-form-field">
          <div className="edit-form-field-row column">
            <div className="edit-form-field">
              <span className="edit-form-subheader">
                Email<sup>*</sup>
              </span>
              <input
                name={"email"}
                placeholder="Type your email address"
                type="email"
                onChange={handleInputChange}
                value={state.email}
                required
              />
            </div>
            <div className="edit-form-field">
              <span className="edit-form-subheader">
                Phone Number<sup>*</sup>
              </span>
              <input
                name={"phone"}
                placeholder="(XXX) XXX-XXXX"
                onChange={(e) => {
                  handleInputChange(e);
                }}
                type="tel"
                value={state.phone}
                minLength={10}
                maxLength={10}
                required
              />
            </div>
          </div>
          <div className="edit-form-field-row column">
            <div className="edit-form-field">
              <span className="edit-form-subheader">WhatsApp</span>
              <input
                key={state.phone}
                name="whatsapp"
                placeholder="Type your WhatsApp number"
                onChange={handleInputChange}
                type="tel"
                value={state.whatsapp}
                minLength={10}
                maxLength={10}
                disabled={state["same as phone"]}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  name="same as phone"
                  onChange={(e) => {
                    handleStateChange({
                      key: "same as phone",
                      value: e.target.checked,
                    });

                    if (e.target.checked) {
                      handleStateChange({
                        key: "whatsapp",
                        value: state.phone,
                      });
                    } else {
                      handleStateChange({
                        key: "whatsapp",
                        value: "",
                      });
                    }
                  }}
                  checked={state["same as phone"]}
                  id="same as phone"
                />
                <label htmlFor="same as phone">Same as Phone</label>
              </div>
            </div>
            <div className="edit-form-field disabled">
              <span className="edit-form-subheader">
                WhatsApp<sup>*</sup>
              </span>
              <input name={"number"} placeholder="(XXX) XXX-XXXX" />
            </div>
          </div>
        </div>
        <div className="edit-page-actions">
          <DeleteIcon size={20} onClick={() => setShowConfirm(!showConfirm)} />
          <button type="submit" className="save-button active">
            Save Changes
          </button>
        </div>
        {showConfirm ? (
          <ConfirmDialog
            title={"Delete Classified"}
            subtitle={"Are you sure you want to delete this classified"}
            onConfirm={() => onDeleteConfirm()}
            onClose={onClose}
          />
        ) : (
          <></>
        )}
      </form>
      {open && (
        <SuccessModal
          title={
            "Thanks for updating your listing. Your updated listing is being reviewed by the admin and will be approved within 24 hours."
          }
          onClose={() => {
            setOpen(false);
            navigate("/dashboard?tab=pending");
          }}
        />
      )}
    </div>
  );
};

export default Edit;
